import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Alert, Row, Col, Table, Button, Pagination, PaginationItem, PaginationLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from "reactstrap";
import axios from 'axios';
import { BASE_URL } from "../../../../constants";

function DepositReport() {
	const [reports, setReports] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [perPage, setPerPage] = useState(20);
	const [perPageDropdownOpen, setPerPageDropdownOpen] = useState(false);
	const [errMsg, setErrMsg] = useState(null);
	const [searchQuery, setSearchQuery] = useState("");
	const [isExporting, setIsExporting] = useState(false);
	console.log(reports, 'reports')
	const navigate = useNavigate();

	useEffect(() => {
		fetchData();
	}, [currentPage, perPage]);

	const togglePerPageDropdown = () => {
		setPerPageDropdownOpen(prevState => !prevState);
	};


	const fetchData = () => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/reports/comparison/list?page_no=${currentPage}&per_page=${perPage}&q=${searchQuery}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						const formattedReports = data.result.data.map(r => {
							const rep = { ...r };
							rep.created_at = new Date(r.created_at).toLocaleDateString('en-US');
							rep.updated_at = new Date(r.updated_at).toLocaleDateString('en-US');
							return rep;
						});
						setReports(formattedReports);
						setTotalPages(data.result.meta_info.total_pages);
					} else {
						console.error("Error: Unable to fetch reports data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	};

	const formatInspectionActivity = (activity) => {
		return activity
			.replace(/_/g, '-')
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	};

	const handleEditReport = (id) => {
		navigate(`/comparison-report-view/${id}`);
	};

	const handlePageClick = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const handlePerPageChange = (value) => {
		setPerPage(value);
		setCurrentPage(1);
	};


	const handleDeleteReport = async (id) => {
		console.log(`Delete report with ID: ${id}`);

		// Ask for confirmation
		const confirmed = window.confirm("Are you sure you want to delete this report?");

		// If user confirms deletion
		if (confirmed) {
			try {
				const token = localStorage.getItem('token');
				if (!token) {
					throw new Error('Authorization token is missing.');
				}

				const response = await axios.delete(`${BASE_URL}/reports/comparison/delete/${id}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				});
				setErrMsg(response.data.message);
				fetchData();

			} catch (error) {
				setErrMsg(error);
			}
		}
	};

	const handleGenerateReport = async (viewInspectionId) => {
		if (!viewInspectionId) return;

		const token = localStorage.getItem('token');

		if (!token) {
			console.error('Error: Authorization token is missing.');
			return;
		}

		try {
			setIsExporting(true)
			const response = await fetch(`${BASE_URL}/reports/comparison/export/${viewInspectionId}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			setIsExporting(false)
			const data = await response.json();
			console.log(data, 'response');

			if (data.status) {
				const newTab = window.open(data.result, '_blank');

				if (newTab) {
					newTab.document.title = 'Comparison Report';
				} else {
					console.error('Failed to open new tab');
				}
			} else {
				setErrMsg(data.message);
			}

		} catch (error) {
			console.error('Error generating PDF:', error);
			setErrMsg(error.message);
		}
	};

	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

			<Row>
				<Col xs="6">
					<h4 className="mt-0">Comparison Reports</h4>
				</Col>

				<Col xs="6" className="text-end">
					<Button color="primary" onClick={() => navigate('/comparison-report-view')}>Create New Comparison Report</Button>
				</Col>
			</Row>


			<Card>
				<CardBody>
					<Table responsive>
						<thead>
							<tr>
								<th>#</th>
								<th>Property</th>
								<th>Inspection</th>
								<th>Inspection</th>
								<th>Created at</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{reports.map((report, index) => (
								<tr key={index}>
									<td>{index + 1}</td>
									<td>
										<strong>{report.property_name}</strong>
										<div className="small text-muted">{report.property_location}</div>
									</td>
									<td>
										<strong>{formatInspectionActivity(report.inspection_1_activity)}</strong>
										<div className="small text-muted">{new Date(report.inspection_1_date).toLocaleDateString('en-US')}</div>
									</td>
									<td>
										<strong>{formatInspectionActivity(report.inspection_2_activity)}</strong>
										<div className="small text-muted">{new Date(report.inspection_2_date).toLocaleDateString('en-US')}</div>
									</td>
									<td>{report.created_at}</td>
									<td>
										<Button color="warning" size="sm" onClick={() => handleEditReport(report.id)}>View</Button>
										<span style={{ marginRight: "5px" }}></span>
										<Button color="primary" size="sm" onClick={() => handleGenerateReport(report.id)} disabled={isExporting}>Export</Button>
										<span style={{ marginRight: "5px" }}></span>
										<Button color="danger" size="sm" onClick={() => handleDeleteReport(report.id)}>Delete</Button>
									</td>
								</tr>
							))}
						</tbody>

					</Table>
				</CardBody>

				<Row>
					<Col xs="4">
						<div style={{ marginLeft: '25px' }}>
							<Dropdown isOpen={perPageDropdownOpen} toggle={togglePerPageDropdown}>
								<DropdownToggle caret color="primary">
									Per Page: {perPage}
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem onClick={() => handlePerPageChange(5)}>5</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(10)}>10</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(20)}>20</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(50)}>50</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
					</Col>

					<Col xs="8" className="text-right">
						<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginRight: '25px', marginTop: '10px' }}>
							<Pagination aria-label="Page navigation example">
								<PaginationItem disabled={currentPage === 1}>
									<PaginationLink

										previous
										onClick={() => handlePageClick(currentPage - 1)}
									/>
								</PaginationItem>

								{currentPage > 3 && (
									<>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(1)}>
												1
											</PaginationLink>
										</PaginationItem>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
									</>
								)}

								{Array.from({ length: 5 }, (_, i) => {
									const page = currentPage <= 3 ? i + 1 : currentPage - 2 + i;
									return (
										page <= totalPages && (
											<PaginationItem key={page} active={currentPage === page}>
												<PaginationLink

													onClick={() => handlePageClick(page)}
												>
													{page}
												</PaginationLink>
											</PaginationItem>
										)
									);
								})}

								{currentPage < totalPages - 2 && (
									<>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(totalPages)}>
												{totalPages}
											</PaginationLink>
										</PaginationItem>
									</>
								)}

								<PaginationItem disabled={currentPage === totalPages}>
									<PaginationLink

										next
										onClick={() => handlePageClick(currentPage + 1)}
									/>
								</PaginationItem>
							</Pagination>

						</div>
					</Col>
				</Row>
			</Card>
		</div>
	);
}

export default DepositReport;
